import { Box, ListItemButton, ListItemIcon, ListItemText, Typography, styled } from "@mui/material";

export interface SidebarGroupLabelProps {
    children: React.ReactNode;
}

const StyledSidebarGroupLabel = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(1.75, 2.5, 0.75),
    fontSize: "0.625rem",
    fontWeight: 700,
    color: theme.palette.text.disabled,
    letterSpacing: "0.07em",
    textTransform: "uppercase",
}));

export const SidebarGroupLabel = ({ children }: SidebarGroupLabelProps) => (
    <StyledSidebarGroupLabel variant="overline">{children}</StyledSidebarGroupLabel>
);

export interface SidebarNavItemProps {
    icon: React.ReactNode;
    label: string;
    selected?: boolean;
    needsAttention?: boolean;
    disabled?: boolean;
    onClick?: () => void;
}

// `MuiListItemButton` is already themed globally (hover / selected / coral
// left-border to match the sidebar), so this stays a thin composition.
export const SidebarNavItem = ({ icon, label, selected, needsAttention, disabled, onClick }: SidebarNavItemProps) => {
    return (
        <ListItemButton selected={selected} disabled={disabled} onClick={onClick}>
            <ListItemIcon sx={{ minWidth: 36, color: "inherit" }}>{icon}</ListItemIcon>
            <ListItemText primary={label} slotProps={{ primary: { sx: { fontSize: "0.8125rem" } } }} />
            {needsAttention && (
                <Box
                    component="span"
                    sx={{
                        ml: "auto",
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        backgroundColor: "primary.main",
                        flexShrink: 0,
                    }}
                />
            )}
        </ListItemButton>
    );
};
